export const HIDE_BALANCE_STORAGE_KEY = 'hide_balance';
export const FIAT_FEATURE_ENABLED = false;
